﻿export const Vimeo = (window as any).Vimeo;
